// extracted by mini-css-extract-plugin
module.exports = {"weekDays":"zOaCnYodMhxayPM2GWbY3","selectedWeekDay":"_1JuBTO_9Xqgg6zFB5hvqKK","weekDay":"FKB-YsP68J72wo6Rc4nSi"};